// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'rounded-pill';

export const Component = () => (
  <rect
    width='17'
    height='5'
    x='.5'
    y='6'
    fill='#D0E0F7'
    stroke='#4185DE'
    strokeLinecap='round'
    strokeLinejoin='round'
    rx='2.5'
  />
);

export const viewBox = '0 0 18 18';
